import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// Enhanced error handling for all errors
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  
  // Only handle specific browser extension errors
  if (event.reason && event.reason.message && 
      event.reason.message.includes('experimental_prefetchInRender')) {
    console.warn('Ignoring experimental_prefetchInRender error (likely from browser extension)');
    event.preventDefault();
    return;
  }
  
  // Log JSON parse errors specifically
  if (event.reason && event.reason.message && 
      (event.reason.message.includes('JSON') || event.reason.message.includes('parse'))) {
    console.error('JSON Parse Error in promise rejection:', event.reason);
  }
});

window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
  
  // Only handle specific browser extension errors
  if (event.error && event.error.message && 
      event.error.message.includes('experimental_prefetchInRender')) {
    console.warn('Ignoring experimental_prefetchInRender error (likely from browser extension)');
    event.preventDefault();
    return;
  }
  
  // Log JSON parse errors specifically
  if (event.error && event.error.message && 
      (event.error.message.includes('JSON') || event.error.message.includes('parse'))) {
    console.error('JSON Parse Error in global error:', event.error);
  }
});

// Add a simple test to see if React can render at all
try {
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error('Root element not found');
  }
  
  console.log('Starting React app...');
  const root = createRoot(rootElement);
  root.render(<App />);
  console.log('React app rendered successfully');
} catch (error) {
  console.error('Failed to render React app:', error);
  document.getElementById("root")!.innerHTML = `
    <div style="padding: 20px; font-family: Arial, sans-serif;">
      <h1>Application Error</h1>
      <p>Failed to load the application: ${error.message}</p>
      <button onclick="window.location.reload()">Reload Page</button>
    </div>
  `;
}
